import { isExchangeBinance, isExchangeBybit, isExchangeTigerX } from '@/utils/lib/exchange'

export function getInitialFilters(exchangeType: string): any {
  const now = new Date()
  const end = new Date(now)
  end.setHours(0, 0, 0, 0) // 00:00:00

  const start = new Date(now)
  start.setDate(now.getDate() - 7)
  start.setHours(0, 0, 0, 0)

  switch (true) {
    case isExchangeTigerX(exchangeType):
      return {
        page: 1,
        pageSize: 20,
        begin: start.getTime(),
        end: end.getTime(),
        businessType: undefined,
        exchange: 'BINANCE',
        sym: undefined,
      }

    case isExchangeBinance(exchangeType):
      return {
        limit: 20,
        startTime: start.getTime(),
        endTime: end.getTime(),
        incomeType: '',
        symbol: '',
        page: 1,
      }

    case isExchangeBybit(exchangeType):
      return {
        limit: '20',
        startTime: start.getTime(),
        endTime: end.getTime(),
        baseCoin: '',
        type: '',
        cursor: '',
      }

    default:
      return {
        pageSize: 20,
        page: 1,
      }
  }
}
